export interface FakeUser {
  directory_group: string[]
  company_name: string
  email: string
  email_verified: boolean
  family_name: string
  given_name: string
  locale: string
  name: string
  preferred_username: string
  sub: string
  updated_at: number
  zoneinfo: string
}

const fakeUser: FakeUser = {
  directory_group: ['directory-internal', 'directory-dealer'],
  company_name: 'Internal',
  email: 'john.doe@doosan.com',
  email_verified: true,
  family_name: 'John',
  given_name: 'Doe',
  locale: 'en-US',
  name: 'John Doe',
  preferred_username: 'johndoe@corp.doosan.com',
  sub: '00uph2ttkqHDNimYs0h7',
  updated_at: 1611063304,
  zoneinfo: 'America/Los_Angeles'
}

export default fakeUser
